import { useContext } from 'react';
import { RoleUIContext } from './role-ui-context';

export interface ElementAccess {
  visible: boolean;
  editable: boolean;
}

const ALLOW_ALL: ElementAccess = { visible: true, editable: true };

export function useElementAccess(key: string): ElementAccess {
  const ctx = useContext(RoleUIContext);
  if (!ctx) return ALLOW_ALL;

  const keys = resolveKeys(key);
  let visible = true;
  let editable = true;

  for (const k of keys) {
    const rule = ctx.elementMap.get(k);
    if (!rule) continue;
    if (rule.visibility === 'hidden') visible = false;
    if (rule.mode === 'view') editable = false;
  }

  // hidden implies not editable — component won't render at all, but keep consistent
  return { visible, editable: visible ? editable : false };
}

function resolveKeys(key: string): string[] {
  const parts = key.split('.');
  const keys = [key];
  if (parts.length === 5 && parts[2] !== parts[3]) {
    keys.push(`${parts[0]}.${parts[1]}.${parts[3]}.${parts[4]}`);
  }
  return keys;
}
